import React, { useContext } from 'react'
import { Col, Row } from 'reactstrap'
import { FormRow } from '@/components/changeRequests'
import { InfoContent, InfoRow } from '@/components/InfoRow'
import Resx from '@/components/Resx'
import { FieldSet } from './helpers/fieldSet'
import { usePropertyReader } from '@/hooks/usePropertyReader'
import { FormContext } from '@/components/changeRequests/formContext'
import { decimalMaxChangeItemValue } from '@/utils/constants'

export const BankCapital = React.memo(function BankCapital () {
  const [hasBankCapital] = usePropertyReader(['hasBankCapital'])
  const { mode } = useContext(FormContext)
  const hideWhenUnchecked = (hasBankCapital ? {} : { style: { display: 'none' } })
  if (mode === 'view' && !hasBankCapital) {
    return (
      <InfoRow>
        <InfoContent><Resx name='Institutions.NoBankCapital' /></InfoContent>
      </InfoRow>
    )
  }
  return (
    <React.Fragment>
      <Row>
        <Col lg='6'>
          <FormRow label='Institutions.BankCapitalTitle' name='hasBankCapital' inputType='checkbox' />
        </Col>
      </Row>
      <Row {...hideWhenUnchecked}>
        <Col lg='6'>
          <FormRow label='Institutions.CurrentCapital' name='bankCapitalCurrentCapital' readonly={!hasBankCapital}
            inputType='number' maxValue={decimalMaxChangeItemValue} />
          <FormRow label='Institutions.SubscriptionShare' name='bankCapitalSubscriptionShare' inputType='number'
            readonly={!hasBankCapital} maxValue={decimalMaxChangeItemValue} />
          <FormRow label='Institutions.PaidCapital' name='bankCapitalPaidCapital' inputType='number'
            readonly={!hasBankCapital} maxValue={decimalMaxChangeItemValue} />
        </Col>
        <Col lg='6'>
          <FormRow label='Institutions.FoundersShare' name='bankCapitalFoundersShare' readonly={!hasBankCapital}
            inputType='number' maxValue={decimalMaxChangeItemValue} />
          <FormRow label='Institutions.CurrentFund' name='bankCapitalCurrentFund' inputType='number' readonly={!hasBankCapital}
            maxValue={decimalMaxChangeItemValue} />
          <FormRow label='Institutions.CapitalAndGeneralReserves' name='bankCapitalCapitalAndGeneralReserves'
            inputType='number' readonly={!hasBankCapital} maxValue={decimalMaxChangeItemValue} />
        </Col>
      </Row>
      <Row {...hideWhenUnchecked}>
        <Col lg='6'>
          <FormRow label='Institutions.DebitDate' name='bankCapitalDebitDate' inputType='date' readonly={!hasBankCapital} />
        </Col>
      </Row>
      <Row {...hideWhenUnchecked}>
        <Col lg='6'>
          <FieldSet className='deposit-memorandum'>
            <FormRow label='Institutions.DepositMemorandumNumber' name='bankCapitalDepositMemorandumNumber'
              readonly={!hasBankCapital} inputProps={{ maxLength: 15 }} />
            <FormRow label='Institutions.DepositMemorandumDate' name='bankCapitalDepositMemorandumDate'
              inputType='date' readonly={!hasBankCapital} />
          </FieldSet>
        </Col>
        <Col lg='6'>
          <FieldSet className='founders-share-deposit'>
            <FormRow label='Institutions.FoundersShareDepositNumber' name='bankCapitalFoundersShareDepositNumber'
              readonly={!hasBankCapital} inputType='number' inputProps={{ integerOnly: true }} />
            <FormRow label='Institutions.FoundersShareDepositAmount' name='bankCapitalFoundersShareDepositAmount'
              inputType='number' readonly={!hasBankCapital} maxValue={decimalMaxChangeItemValue} />
            <FormRow label='Institutions.FoundersShareDepositDate' name='bankCapitalFoundersShareDepositDate'
              inputType='date' readonly={!hasBankCapital} />
          </FieldSet>
        </Col>
      </Row>
      <Row {...hideWhenUnchecked}>
        <Col lg='12'>
          <FormRow label='Common.Description' name='bankCapitalDescription' inputType='textarea' readonly={!hasBankCapital} />
        </Col>
      </Row>
    </React.Fragment>
  )
})



// WEBPACK FOOTER //
// ./src/components/demographics/bankCapital.js